import category from './category.reducer'
import { combineReducers } from 'redux'
import course from './course.reducer'
import disability from './disability.reducer'
import discipline from './discipline.reducer'
import education from './education.reducer'
import exam from './exam.reducer'
import helper from './helper.reducer'
import quiz from './quiz.reducer'
import quizcategory from './quizcategory.reducer'
import quizquestion from './quizquestion.reducer'
import { reducer as reduxFormReducer } from 'redux-form'
import subject from './subject.reducer'
import tag from './tag.reducer'
import tenant from './tenant.reducer'
import user from './user.reducer'

const rootReducer = combineReducers({
  userReducer: user,
  examReducer: exam,
  categoryReducer: category,
  disabilityReducer: disability,
  courseReducer: course,
  disciplineReducer: discipline,
  helperReducer: helper,
  educationReducer: education,
  subjectReducer: subject,
  tagReducer: tag,
  quizCategoryReducer: quizcategory,
  quizQuestionReducer: quizquestion,
  quizReducer: quiz,
  tenantReducer: tenant,
  form: reduxFormReducer
})

export default rootReducer